import { Stack } from '@mui/material';
import type { BackupVault, RestoreAccount } from '@repo/api-gw-sdk';

import {
  VaultOwnBucketCopyableAllAccountsPolicy,
  VaultOwnBucketCopyablePolicy,
} from '@/components/vaults/vaultOwnBucketCopyablePolicy';
import { VaultOwnBucketEditKeyPolicyButton } from '@/components/vaults/vaultOwnBucketEditKeyPolicyButton';

export const OwnBucketSuggestedPolicyDialogBody = ({
  backupVault,
  restoreAccounts,
}: {
  backupVault: BackupVault;
  restoreAccounts?: RestoreAccount[];
}) => {
  return (
    <Stack paddingX='40px' gap='24px' alignItems='flex-end'>
      {restoreAccounts ? (
        <VaultOwnBucketCopyablePolicy
          bucketName={backupVault.vaultAttributes.aws?.bucketName || ''}
          restoreAccounts={restoreAccounts}
        />
      ) : (
        <VaultOwnBucketCopyableAllAccountsPolicy
          bucketName={backupVault.vaultAttributes.aws?.bucketName || ''}
        />
      )}
      <VaultOwnBucketEditKeyPolicyButton
        region={backupVault.region}
        bucketName={backupVault.vaultAttributes.aws?.bucketName || ''}
      />
    </Stack>
  );
};
